import React from 'react';
import {useSuffix} from '../hooks';
import {InputProps} from '../types';

function withSuffix<P extends InputProps>(
	Component: React.ComponentType<P>,
): React.ForwardRefRenderFunction<HTMLInputElement, P & {suffix: string}> {
	// @ts-ignore
	return React.forwardRef((props, ref) => {
		// @ts-ignore
		return <Component {...useSuffix({ref, ...props})} />;
	});
}

export default withSuffix;
